import { useCallback, useMemo } from "react";
import { ConvexProviderWithAuth } from "convex/react";
import { jsx } from "react/jsx-runtime";

//#region src/index.tsx
/**
* A wrapper React component which provides a {@link react.ConvexReactClient}
* authenticated with WorkOS AuthKit.
*
* It must be wrapped by a configured `AuthKitProvider`, from
* `@workos-inc/authkit-react`.
*
* @public
*/
function ConvexProviderWithAuthKit({ children, client, useAuth }) {
	const useAuthFromWorkOS = useUseAuthFromAuthKit(useAuth);
	return /* @__PURE__ */ jsx(ConvexProviderWithAuth, {
		client,
		useAuth: useAuthFromWorkOS,
		children
	});
}
function useUseAuthFromAuthKit(useAuth) {
	return useMemo(() => function useAuthFromWorkOS() {
		const { isLoading, user, getAccessToken } = useAuth();
		const fetchAccessToken = useCallback(async () => {
			try {
				const token = await getAccessToken();
				return token;
			} catch {
				return null;
			}
		}, [getAccessToken]);
		return useMemo(() => ({
			isLoading,
			isAuthenticated: !!user,
			fetchAccessToken
		}), [
			isLoading,
			user,
			fetchAccessToken
		]);
	}, [useAuth]);
}

//#endregion
export { ConvexProviderWithAuthKit };
//# sourceMappingURL=index.js.map